export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3">
            Podstawy
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Czym jest Kakobuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Kakobuy Spreadsheet to uporządkowana baza produktów, która pomaga użytkownikom znaleźć popularne produkty z chińskich marketplace takich jak Taobao, Weidian i 1688. Zamiast spędzać godziny na przeszukiwaniu setek stron, otrzymujesz gotową listę sprawdzonych i popularnych produktów w jednym miejscu.
          </p>
        </div>

        <div className="max-w-2xl mx-auto overflow-hidden rounded-lg border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800">Metoda</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800">Czas wyszukiwania</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800">Łatwość</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-background-200/60">
              <tr className="hover:bg-background-100/50 transition-colors">
                <td className="px-5 py-3.5 font-medium text-foreground-950 flex items-center gap-2">
                  <i className="ri-star-fill text-accent-500 text-sm"></i>
                  Kakobuy Spreadsheet
                </td>
                <td className="px-5 py-3.5 text-foreground-700">Kilka minut</td>
                <td className="px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 text-accent-500 font-semibold">
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-background-100/50 transition-colors">
                <td className="px-5 py-3.5 font-medium text-foreground-950">Samodzielne szukanie</td>
                <td className="px-5 py-3.5 text-foreground-700">Kilka godzin</td>
                <td className="px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 text-secondary-500 font-semibold">
                    <i className="ri-star-fill text-xs"></i>
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-background-100/50 transition-colors">
                <td className="px-5 py-3.5 font-medium text-foreground-950">Losowe linki</td>
                <td className="px-5 py-3.5 text-foreground-700">Ryzyko</td>
                <td className="px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 text-foreground-400 font-semibold">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}